// searchService.js
import { api } from './config';

const searchService = {
  /**
   * Crea/ejecuta una búsqueda nueva (o manual).
   * @param {string} query
   * @param {Array} results
   * @param {Object} suggestions
   */
  createSearch: async (query, results = [], suggestions = {}) => {
    try {
      const response = await api.post('/search', {
        query,
        results,
        suggestions
      });
      return response.data;
    } catch (error) {
      console.error('[searchService] Error creating search:', error);
      throw error;
    }
  },

  /**
   * Obtiene historial de búsquedas del usuario autenticado
   */
  getUserHistory: async () => {
    try {
      const response = await api.get('/search/user-history');
      return response.data;
    } catch (error) {
      console.error('[searchService] Error getting user history:', error);
      throw error;
    }
  },

  /**
   * Obtiene un registro por ID
   */
  getSearchById: async (searchId) => {
    try {
      const response = await api.get(`/search/${encodeURIComponent(searchId)}`);
      return response.data;
    } catch (error) {
      console.error('[searchService] Error getSearchById:', error);
      throw error;
    }
  }
};

export default searchService;
